import { useFormContext } from 'react-hook-form';
import { RadioField, NumberSelectField, TextField } from '@views/register/history/history-fields';
import type { TLocalize } from '@hooks/use-localize';
import type { IHistoryDiagnosedFormValues, IHistoryDiagnosedModel } from '@/types/history/history-diagnosed';

interface IProps {
    model: IHistoryDiagnosedModel;
    t: TLocalize;
}

const OtherConditionsSection = ({ model, t }: IProps) => {
    const { watch } = useFormContext<IHistoryDiagnosedFormValues>();

    const yn = model.yesNoUnknownOptions;
    const yes = String(model.yesValue);
    const please = t('DashLabel_PleaseSelect', 'Please Select');

    return (
        <>
            <div className='section-heading'>Other Conditions</div>

            <RadioField
                name="hasReceivedTransfusion"
                label={t('DashLabel_HaveYouEverHadABloodTransfusion', 'Have you ever had a blood transfusion')}
                options={yn}
            />
            {watch('hasReceivedTransfusion') === yes && (
                <div className="sub-question">
                    <NumberSelectField
                        name="howManyTransfusions"
                        label={t('DashLabel_HowManyTransfusions', 'How many transfusions')}
                        max={5}
                        plusLast
                        placeholder={please}
                    />
                </div>
            )}

            {!model.useReducedQuestions && (
                <RadioField
                    name="hasHistoryOfObesity"
                    label={t('DashLabel_DoYouHaveAHistoryOfObesity', 'Do you have a history of obesity')}
                    options={yn}
                />
            )}

            <RadioField
                name="hasFabrys"
                label={t('DashLabel_DoYouHaveAHistoryOfFabrySDisease', "Do you have a history of Fabry's Disease")}
                options={yn}
            />
            <RadioField
                name="hasSickleCell"
                label={t('DashLabel_DoYouHaveSickleCellDisease', 'Do you have Sickle Cell Disease')}
                options={yn}
            />
            <RadioField
                name="hasSickleCellTrait"
                label={t('DashLabel_HaveYouEverBeenToldYouHaveTheSickleCellTrait', 'Have you ever been told you have the Sickle Cell Trait')}
                options={yn}
            />
            <RadioField
                name="hasSarcoidosis"
                label={t('DashLabel_DoYouHaveAHistoryOfSarcoidosis', 'Do you have a history of Sarcoidosis')}
                options={yn}
            />

            <RadioField
                name="hasAutoImmune"
                label={t('DashLabel_DoYouHaveAHistoryOfAnAutoImmuneDisease', 'Do you have a history of an auto-immune disease')}
                options={yn}
            />
            {watch('hasAutoImmune') === yes && (
                <div className="sub-question">
                    <TextField
                        name="autoImmuneDescription"
                        label={t('DashLabel_WhatAutoImmuneDiseaseS', 'What auto-immune disease(s)')}
                        maxLength={255}
                    />
                </div>
            )}
        </>
    );
};

export default OtherConditionsSection;
